import { ROUTES } from '~/data/routes';
import { CarCardType } from '~/data/types/car/cars';
import { useMemo } from 'react';
import { useCurrentUrlParams } from '~/hooks/useCurrentUrlParams';
import { CAR_FLOW_TYPE } from '~/data/car/carCardData';
import { EUrlParam } from '~/data/urlParams';

export const useCarSubscriptionPageUrl = (
  car: CarCardType,
  dealType: CAR_FLOW_TYPE,
) => {
  const currentUrlParams = useCurrentUrlParams({ cleanAppParams: true });

  return useMemo(() => {
    currentUrlParams.set(EUrlParam.DEAL_TYPE, dealType);
    const paramsString = currentUrlParams.toString();
    const queryParams = paramsString ? `?${paramsString}` : '';

    return `${
      ROUTES.CAR_PAGE
    }/${car?.year}-${car?.carZoneMakeNameEn?.toLocaleLowerCase()}-${car?.carZoneModelNameEn
      ?.toLocaleLowerCase()
      .replaceAll(' ', '-')}-c${car?.id}${queryParams}`;
  }, [
    car?.carZoneMakeNameEn,
    car?.carZoneModelNameEn,
    car?.id,
    car?.year,
    currentUrlParams,
    dealType,
  ]);
};
